import React from 'react';

const copy = {
  english: {
    eyebrow: 'About',
    title: 'Built for quick surf checks',
    description:
      'This app gives a quick surf overview for Apelviken with weather, wind, map-based conditions, surf score, and wetsuit guidance.',
    credits: 'Credits',
    design: 'Original project by Jody Swartz',
  },
  swedish: {
    eyebrow: 'Om',
    title: 'Byggd för snabba surfkollar',
    description:
      'Den här appen ger en snabb surföversikt för Apelviken med väder, vind, kartbaserade förhållanden, surfpoäng och våtdräktsrekommendation.',
    credits: 'Tack',
    design: 'Originalprojekt av Jody Swartz',
  },
};

const AboutContent = ({ language }) => {
  const text = copy[language] || copy.english;

  return (
    <section className="panel about-panel">
      <p className="eyebrow">{text.eyebrow}</p>
      <img
        src={`${process.env.PUBLIC_URL}/logo512.png`}
        alt="Apelviken Logo"
        className="about-logo"
      />
      <h2>{text.title}</h2>
      <p className="hero-copy">{text.description}</p>
      <div className="about-meta">

        <div>
          <span>{text.credits}</span>
          <strong>{text.design}</strong>
        </div>
      </div>
    </section>
  );
};

export default AboutContent;